import React from "react";
import { Link } from "react-router-dom";
import "./About.css";
import aboutImage from "../Images/dashboard_screenshot-–-Updated-No-Footer-1.webp"; // Ensure correct path

const About = () => {
  return (
    <div className="container about-section">
      <div className="row align-items-center">
        {/* Left Column: Scrolling Image */}
        <div className="col-lg-8 col-md-6 col-12 image-container border-2">
          <img src={aboutImage} alt="About Us" className="scrolling-image" />
        </div>

        {/* Right Column: Heading & Text */}
        <div className="col-lg-4 col-md-6 col-12 text-content">
        <video
              className="hero-video2"
              width="200"
              autoPlay
              muted
              loop
              playsInline
            >
              <source src={`${process.env.PUBLIC_URL}/large.mp4`} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            {/* <button className="btn3">Get started</button> */}
             
            <Link
               to="/get-started#payment-section"
              className="btn3 text-decoration-none mt-4"
              // id="btn2"
            >
              Get Started
            </Link>

        

            </div>
        
      </div>
    </div>
  );
};

export default About;
